

































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { processServe } from '@/api/installServer';
@Component({
  components: {},
})
export default class ProcessAdvanced extends Vue {
  @Prop() private formData: any;
  @Watch('formData', { deep: true })
  private getBase() {
    const data = {
      baseConfig: this.formData,
      type: 'base',
    };
    this.$emit('setFormData', data);
  }
}
